import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@folio/components/ui/alert-dialog';
import { Loader2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DeleteDocumentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  documentName: string;
  isDeleting?: boolean;
}

export function DeleteDocumentDialog({
  open,
  onOpenChange,
  onConfirm,
  documentName,
  isDeleting = false,
}: DeleteDocumentDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="overflow-hidden">
        <AlertDialogHeader className="min-w-0">
          <AlertDialogTitle className="truncate">
            {t('deleteDocumentDialog.title', { name: documentName })}
          </AlertDialogTitle>
          <AlertDialogDescription>{t('deleteDocumentDialog.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>
            {t('deleteDocumentDialog.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={e => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isDeleting}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Loader2Icon className="mr-2 h-4 w-4 animate-spin" />
                {t('deleteDocumentDialog.deleting')}
              </>
            ) : (
              t('deleteDocumentDialog.confirm')
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
